import { jsx as _jsx } from "react/jsx-runtime";
import { boxStyle, normalizeStyle } from '../Box/Box';
function resolveTemplate(value) {
    return typeof value === 'number' ? `repeat(${value}, 1fr)` : value;
}
export function Grid({ as: Tag = 'div', columns, rows, gap, alignItems, justifyItems, children, className, style: extraStyle, ...boxProps }) {
    // Emit gap as rowGap/columnGap longhand to keep style serialization
    // deterministic across SSR + hydration. See Box.tsx normalizeStyle for why.
    const gapValue = gap != null ? `var(--space-${gap})` : undefined;
    const style = {
        display: 'grid',
        ...(columns != null ? { gridTemplateColumns: resolveTemplate(columns) } : {}),
        ...(rows != null ? { gridTemplateRows: resolveTemplate(rows) } : {}),
        ...(gapValue != null ? { rowGap: gapValue, columnGap: gapValue } : {}),
        ...(alignItems ? { alignItems } : {}),
        ...(justifyItems ? { justifyItems } : {}),
        ...boxStyle(boxProps),
        ...normalizeStyle(extraStyle),
    };
    return (_jsx(Tag, { className: className, style: style, children: children }));
}
//# sourceMappingURL=Grid.js.map